import { PGetAllRegimeTvaAsync } from '@/api/parametrage';

export default async function getRegimeTvaDefault(societeId, regimeTvaId) {
  const listeTauxTva = (await PGetAllRegimeTvaAsync(societeId)).data.result.items;
  if (regimeTvaId != null) {
    const regimeTva = listeTauxTva.find(elt => elt.id === regimeTvaId);
    return regimeTva === null ? Math.max(...listeTauxTva.map(taux => taux.tauxTva))
      : regimeTva.tauxTva;
  }
  return Math.max(...listeTauxTva.map(taux => taux.tauxTva));
}



// WEBPACK FOOTER //
// ./src/services/devisCommandes/regimeTvaDefault.js